module.exports = __webpack_public_path__ + "static/media/bulk_couriers_force_close_sample.d3a18f38.csv";